import { Component, Input } from '@angular/core';
import { Order } from '../../../../graphql/generated/generated-types';
import { FormatPricePipe } from '../../../pipes/format-price.pipe';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-item-payment-totals',
  standalone: true,
  imports: [CommonModule, FormatPricePipe],
  templateUrl: './item-payment-totals.component.html',
  styleUrl: './item-payment-totals.component.scss'
})
export class ItemPaymentTotalsComponent {
  @Input() order: Order;
  @Input() standalone: boolean = false;
  @Input() itemGroups: boolean = true;
  @Input() darkMode: boolean = false;
}
